import type { FileUserAnnotation } from "@alaffia-technology-solutions/schema";

import { apiClient } from "@alaffia-technology-solutions/client-sdk-react-query";

export function useAnnotationLabels() {
  return apiClient.files.getAnnotationLabels.useQuery({});
}

interface UseFileUserAnnotationsOptions {
  fileId: string | null;
}

export function useFileUserAnnotations({
  fileId,
}: UseFileUserAnnotationsOptions) {
  return apiClient.files.getFileUserAnnotations.useQuery(
    {
      fileId: fileId!,
    },
    {
      enabled: !!fileId,
    },
  );
}

interface UseCreateFileUserAnnotationOptions {
  fileId: string;
  onSuccess?: (annotation: Omit<FileUserAnnotation, "creator"> | null) => void;
}

export function useCreateFileUserAnnotation({
  fileId,
  onSuccess,
}: UseCreateFileUserAnnotationOptions) {
  const getFileUserAnnotationsCtx =
    apiClient.files.getFileUserAnnotations.useQueryContext();

  return apiClient.files.createFileAnnotation.useMutation({
    onSuccess: async (annotation) => {
      onSuccess?.(annotation);

      return getFileUserAnnotationsCtx.invalidate({ fileId });
    },
  });
}

interface UseDeleteFileUserAnnotationOptions {
  fileId: string;
  onSuccess?: () => void;
}

export function useDeleteFileUserAnnotation({
  fileId,
  onSuccess,
}: UseDeleteFileUserAnnotationOptions) {
  const getFileUserAnnotationsCtx =
    apiClient.files.getFileUserAnnotations.useQueryContext();

  return apiClient.files.deleteFileAnnotation.useMutation({
    onSuccess: async () => {
      onSuccess?.();

      return getFileUserAnnotationsCtx.invalidate({ fileId });
    },
  });
}
